import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {LOGIN_SUCCESS, RE_LOGIN_SUCCESS} from '../../actions/login/index';
// import { doActivePage } from '../../actions/menu/index';
// import MainHeader from '../../components/frame/MainHeader';
// import MainFooter from '../../components/frame/MainFooter';
import { openModal } from '../../actions/index';
import Loading from '../../components/common/Loading';
import ApplyAccountForm from '../../components/login/ApplyAccountForm';
import { doActivePage } from '../../actions/menu/index';
import '../../resources/css/layout/SignupLayout.scss';
import ModalConfirm from '../../components/common/ModalConfirm';
import ModalTip from '../../components/common/ModalTip';
import ModalAlert from '../../components/common/ModalAlert';
import ModalLoading from '../../components/common/ModalLoading';


class SignupLayout extends Component {

  constructor(props) {
    super(props);
    const { activePage, doActivePage } = this.props;
    if (activePage !== 'Signup') {
      doActivePage('Signup');
    }
  }

componentDidUpdate (prevProps, prevState, snapshot) {
  const { menuActivePage, history } = this.props;

  if (prevProps.menuActivePage !== menuActivePage) {
    if (menuActivePage && history) {
      history.push(window.CONFIG.WEB_ROOT + '/' + menuActivePage);
    }
  }
}

  loginAccount = () => {
    const { history } = this.props;
    history.push(window.CONFIG.WEB_ROOT + '/Login');
  }

  render() {
    const { status, loading } = this.props;
    
    if (status === LOGIN_SUCCESS || status === RE_LOGIN_SUCCESS) {      
      return (
        <Redirect to={{
          pathname: window.CONFIG.WEB_ROOT + window.CONFIG.DEFAULT_MAIN_PAGE
        }}/>
      );
    }

    return (
      <div className='area-signup-page'>
        <div className='area-logo'>
          <span className='icon-logo-prism-dark'/>
        </div>
        <div className='area-signup-block'>          
          <div className='area-signup-logo-word'>
            <span className='logo-word'>Create a Prism Account</span>
          </div>
          <div className='area-signin-word' onClick={ this.loginAccount }>
            <span className='have-account-word'>Already have an account?</span><span className='signin-link href-class'>Sign in</span>
          </div>
          <ApplyAccountForm forwardLoginPage={this.loginAccount}></ApplyAccountForm>
          <Loading loading={loading} center={true}></Loading>
        </div>
        {/* <div className='main-footer'>
          <MainFooter/>
        </div>*/}
        {/* <ModalForgotPwd></ModalForgotPwd> */}
        {/* <ModalApplyAccountDetail></ModalApplyAccountDetail> */}
        <ModalConfirm></ModalConfirm>
			  <ModalTip></ModalTip>
        <ModalAlert></ModalAlert>
        <ModalLoading></ModalLoading>
      </div>      
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // const errMsg = ownProps.location.state ? ownProps.location.state.errMsg : null;

  return {
    // errMsg: errMsg || state.loginReducers.errMsg,
    menuActivePage: state.menuReducers.activePage,
    status: state.loginReducers.status,
    loading: state.loginReducers.loading
  }
}

export default connect(
  mapStateToProps,
  { openModal, doActivePage }
)(SignupLayout)